import { render, staticRenderFns } from "./TheGroupMember.vue?vue&type=template&id=3cdc754e&scoped=true"
import script from "./TheGroupMember.vue?vue&type=script&lang=js"
export * from "./TheGroupMember.vue?vue&type=script&lang=js"
import style0 from "./TheGroupMember.vue?vue&type=style&index=0&id=3cdc754e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc754e",
  null
  
)

export default component.exports